export default "__VITE_ASSET__BoCXgouH__"